import { useMemo } from "react";
import { WizardConfig, WizardStepConfig } from "../definitions";

export const useWizardConfig = (config: WizardConfig) => {
  const steps = useMemo(() => config.steps, [config.steps]);

  const totalSteps = useMemo(() => steps.length, [steps]);

  const isValidStepIndex = useMemo(() => {
    return (stepIndex: number) => stepIndex >= 0 && stepIndex < totalSteps;
  }, [totalSteps]);

  const getStepConfig = useMemo(() => {
    return (stepIndex: number): WizardStepConfig | null => {
      if (!isValidStepIndex(stepIndex)) {
        return null;
      }
      return steps[stepIndex];
    };
  }, [steps, isValidStepIndex]);

  const isLastStep = useMemo(() => {
    return (stepIndex: number) => stepIndex === totalSteps - 1;
  }, [totalSteps]);

  const isFirstStep = useMemo(() => {
    return (stepIndex: number) => stepIndex === 0;
  }, []);

  const getSubmitButtonText = useMemo(() => {
    return (stepIndex: number) => {
      if (isLastStep(stepIndex)) {
        return config.submitButtonText || "Create";
      }
      return "Next";
    };
  }, [config.submitButtonText, isLastStep]);

  return {
    steps,
    totalSteps,
    isValidStepIndex,
    getStepConfig,
    isLastStep,
    isFirstStep,
    getSubmitButtonText,
    category: config.category,
    onComplete: config.onComplete,
    onCancel: config.onCancel,
    cancelButtonText: config.cancelButtonText || "Cancel",
  };
};
